import React from "react";

export const VideoPlayer = ({ video, hasControls, isAutoPlay }) => {
  if (!video || video.media_type !== "video") return null;

  const source = video.sources?.[0];
  const previewImage = video.preview_image?.src;

  const videoUrl = source?.url?.startsWith("//")
    ? "https:" + source.url
    : source?.url;

  const posterUrl = previewImage?.startsWith("//")
    ? "https:" + previewImage
    : previewImage;

  return (
    <video
      controls={hasControls}
      autoPlay={isAutoPlay}
      poster={posterUrl}
      muted
      className="video-player w-full min-h-[200px] sm:min-h-[280px] md:min-h-[360px] lg:min-h-[200px] xl:min-h-[300px]"
    >
      <source src={videoUrl} type={source?.mime_type} />
      Your browser does not support the video tag.
    </video>
  );
};

export default VideoPlayer;
